import React from 'react';
import PropTypes from 'prop-types';

/**
 * Subtitle - A wrapper that renders a standard HTML heading with Bulma class names
 * 
 * This component accepts the same props as Bloomer Subtitle for easy migration
 */
const Subtitle = ({
  className,
  children,
  style,
  tag: Tag = 'h2',
  isSize,
  hasTextAlign,
  hasTextColor,
  isMarginless,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['subtitle'];
    
    // Add appropriate classes based on props
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    if (hasTextAlign) {
      classes.push(`has-text-${hasTextAlign}`);
    }
    
    if (hasTextColor) {
      classes.push(`has-text-${hasTextColor}`);
    }
    
    if (isMarginless) {
      classes.push('is-marginless');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <Tag className={getClassNames()} style={style} {...props}>
      {children}
    </Tag>
  );
};

Subtitle.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  isSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  hasTextAlign: PropTypes.string,
  hasTextColor: PropTypes.string,
  isMarginless: PropTypes.bool
};

Subtitle.defaultProps = {
  className: '',
  style: {},
  children: null,
  tag: 'h2',
  isSize: null,
  hasTextAlign: null,
  hasTextColor: null,
  isMarginless: false
};

export default Subtitle;
